/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/1/20
 * Time: 4:06 PM
 */
import React, {Component} from 'react';
import SockJsClient from 'react-stomp';
import {connect} from 'react-redux';
import * as actionCreator from '../../../store/Action';
import * as serverUrl from '../../../axios/axios_public_urls';
import Cookies from "js-cookie";
import * as keys from '../../../const/key/Key';
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import {withTranslation} from "react-i18next";

let SEND_MESSAGE_GET_CURRENT_QUEUE_QUESTION = ({branchId}) => `/app/currentQueue/branch/${branchId}`;
let SEND_MESSAGE_DELETE_VISITORS_LIST = ({branchId}) => `/app/currentQueue/delete/branch/${branchId}/user`;

let TOPIC_BRANCH_VISITORS = ({branchId}) => `/currentQueue/branch/${branchId}`;
let TOPIC_BRANCH_VISITOR_CUSTOMIZE_ARRAY = ({branchId}) => `/currentQueue/branch/${branchId}/user`;
let TOPIC_EVENT_DISPLAY_QUESTION = `/topic/question`;

let reConnect = 0;

class ReceptSocketConfiguration extends Component {
  state = {
    reConnect: true
  };

  socketMessage = (result, topic) => {
    console.log(`\nsocket_topic: ${topic},\n socket_result`, result,`\n`);

    if (topic === TOPIC_EVENT_DISPLAY_QUESTION) {
      this.props.questionHandler(result);

    } else if (topic === TOPIC_BRANCH_VISITORS({branchId: this.props.branchId})) {
      if(result['body'].success) this.props.socketFetchAllBranchVisitorsHandler(result['body'].visitors);

    } else if (topic === TOPIC_BRANCH_VISITOR_CUSTOMIZE_ARRAY({branchId: this.props.branchId})) {
      this.props.socketAddNewBranchVisitorHandler(result);
    }
  };

  onConnectFailure = name => (msg) => {
    const {t} = this.props;
    if(reConnect === 5){
      this.setState({reConnect: false});
      swal({
        title: "The current session in the visitor queue cannot be updated. Please refresh the page.",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: t('cancel'),
          dangerMode: {
            text: t('refresh'),
            value: "action",
            className: "okay-btn"
          }
        },
      })
        .then((value) => {
          switch (value) {
            case "action":
             window.location = window.location.href;
              break;
            default:
          }
        });
    }
    reConnect++;
    console.log(`socket_onConnectFailure :${name}, msg`, msg);
  };
  onConnect = name => () => {
    console.log(`socket_onConnect :${name}`);
    if (name === keys.TOPIC_VISITOR_QUEUE) {
      this.socketSendMessageToBackend(SEND_MESSAGE_GET_CURRENT_QUEUE_QUESTION({branchId: this.props.branchId}));
    }
  };

  socketSendMessageToBackend = (name,obj) => {
    this.receptSocketRef.sendMessage(name,obj?JSON.stringify(obj):undefined);
  };

  onDisconnect = name => (msg) => {
    console.log(`socket_onDisconnect :${name}, msg`, msg);
  };

  componentWillReceiveProps(nextProps) {
    let idList = nextProps.idList;
    if (idList.length !== 0) {
      this.socketSendMessageToBackend(SEND_MESSAGE_DELETE_VISITORS_LIST({branchId: this.props.branchId}), {users:idList});
      // this.socketSendMessageToBackend("/currentQueue/delete/branch/2/user", {users:idList});
      this.props.socketSelectBranchVisitorHandler(0); // reset the select user id to the default value
    }
  };

  render() {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let {focus, branchId} = this.props;
    let {reConnect} = this.state;
    return (
      <div>
        {focus === keys.TOPIC_QUESTION ?
        <SockJsClient
          url={`${serverUrl.EVENT_SOCKET_URL}websocket-socket`}
          topics={[TOPIC_EVENT_DISPLAY_QUESTION]}
          headers={headers}
          autoReconnect={true}
          debug={true}
          onConnectFailure={this.onConnectFailure(focus)}
          onConnect={this.onConnect(focus)}
          onDisconnect={this.onDisconnect(focus)}
          ref={(client) => {
            this.receptSocketRef = client
          }}
          onMessage={this.socketMessage}/>:null}

        {focus === keys.TOPIC_VISITOR_QUEUE && branchId ?
        <SockJsClient
          url={`${serverUrl.RECEPT_FR_SOCKET_URL}websocket-socket?access_token=${Cookies.get("68a6102f6ed24899420170004a0273b8")}`}
          topics={[TOPIC_BRANCH_VISITORS({branchId: branchId}),TOPIC_BRANCH_VISITOR_CUSTOMIZE_ARRAY({branchId: branchId})]}
          headers={headers}
          autoReconnect={reConnect}
          debug={true}
          onConnectFailure={this.onConnectFailure(focus)}
          onConnect={this.onConnect(focus)}
          onDisconnect={this.onDisconnect(focus)}
          ref={(client) => {
            this.receptSocketRef = client
          }}
          onMessage={this.socketMessage}/>:null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  result: state.socketReducer.result,
  userId: state.receptSocketReducer.userId,
  branchId: state.receptSocketReducer.branchId,
  idList: state.receptSocketReducer.idList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // socket data store
    questionHandler: (data) => dispatch(actionCreator.questionHandler(data)),
    socketSelectBranchVisitorHandler: (data) => dispatch(actionCreator.socketSelectBranchVisitorHandler(data)),
    socketAddNewBranchVisitorHandler: (data) => dispatch(actionCreator.socketAddNewBranchVisitorHandler(data)),
    socketFetchAllBranchVisitorsHandler: (data) => dispatch(actionCreator.socketFetchAllBranchVisitorsHandler(data)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceptSocketConfiguration));
